import { Button } from 'blaze-ui/Button'
import Styles from './BrandVisualStyleMedia.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

export const RecommendationBanner = ({ onPress }: { onPress: () => void }) => {
  return (
    <div className={Styles.recommendationBanner}>
      <div className={Styles.title}>
        <Heading level={3}>We recommend switching to Stylized Photos & Videos</Heading>
        <Text variant="primary">
          Use Stylized Videos & Photos to generate endless, consistent media—otherwise your current uploads may run out
          quickly.
        </Text>
      </div>
      <Button size="xl" onPress={onPress}>
        Switch to Stylized Photos & Videos
      </Button>
    </div>
  )
}
